/* import __COLOCATED_TEMPLATE__ from './market-input-phone.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { schedule, next } from '@ember/runloop';
import environment from '@square/environment-utils/environment';
import { isEmpty } from '@ember/utils';
const MAX_PHONE_NUMBER_LENGTH = 20;
let MarketInputPhone = (_dec = service('formatter'), (_class = class MarketInputPhone extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
    _initializerDefineProperty(this, "formatterService", _descriptor2, this);
    // internal
    _defineProperty(this, "focused", false);
    _defineProperty(this, "input", null);
    _defineProperty(this, "maxPhoneNumberLength", MAX_PHONE_NUMBER_LENGTH);
  }
  get displayValue() {
    return this.format(this.args.value);
  }
  format(phoneNumber) {
    const parsedNumber = this.removeFormatting(phoneNumber);
    return this.formatterService.getPhoneNumberFormatter().format(parsedNumber);
  }
  removeFormatting(formattedPhoneNumber) {
    if (isEmpty(formattedPhoneNumber)) {
      return formattedPhoneNumber;
    }
    return formattedPhoneNumber.replace(/\D/g, '');
  }
  inputEventListener() {
    const inputElement = this.input;
    const inputValue = inputElement.value;
    const cursorPosition = inputElement.selectionStart;
    const formattedValue = this.format(inputValue);

    // if the cursorPosition isn't at the end of the line then we don't want it to jump to the end
    //  so we pass in the cursorPosition to the update function
    if (cursorPosition !== inputValue.length) {
      this.updateAndRenderValue({
        inputElement,
        formattedValue,
        cursorPosition
      });
    }
    this.updateAndRenderValue({
      inputElement,
      formattedValue
    });
  }
  keyDownEventListener(e) {
    const inputElement = this.input;
    const inputValue = inputElement.value;
    const cursorPosition = inputElement.selectionStart;
    if (e.key === 'Backspace' && (inputValue[cursorPosition - 1] === '-' || inputValue[cursorPosition - 1] === ' ' || inputValue[cursorPosition - 1] === ')' || inputValue[cursorPosition - 1] === '(')) {
      e.preventDefault();
      const cursorPositionWithoutDeletedChars = cursorPosition - 2;
      const inputValueWithoutDeletedChars = inputValue.slice(0, cursorPositionWithoutDeletedChars) + inputValue.slice(cursorPosition);

      // Re-format the value and find the new cursor position.
      const formattedValue = this.format(inputValueWithoutDeletedChars);
      this.updateAndRenderValue({
        inputElement,
        formattedValue,
        cursorPosition
      });
    }
    if (e.key === 'Delete' && (inputValue[cursorPosition] === '-' || inputValue[cursorPosition] === ' ' || inputValue[cursorPosition] === ')' || inputValue[cursorPosition] === '(')) {
      e.preventDefault();
      const inputValueWithoutDeletedChars = inputValue.slice(0, cursorPosition) + inputValue.slice(cursorPosition + 2);

      // Re-format the value and find the new cursor position.
      const formattedValue = this.format(inputValueWithoutDeletedChars);
      this.input.setSelectionRange(cursorPosition, cursorPosition);
      // We've modified the value by deleting a digit. Update visible and internal state.
      this.updateAndRenderValue({
        inputElement,
        formattedValue,
        cursorPosition
      });
    }
  }
  updateAndRenderValue({
    inputElement,
    formattedValue,
    cursorPosition
  }) {
    this.input.value = formattedValue;
    this.args.onChange?.(this.removeFormatting(formattedValue));
    if (cursorPosition) {
      if (environment().isTesting) {
        // Tests require us to defer this work to a future runloop, otherwise the cursor
        // is set to the end of the input _after_ we do this.
        next(this, () => {
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      } else {
        schedule('afterRender', this, () => {
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    }
  }
  async didInsert(marketInput) {
    this.input = await marketInput.getInputElement();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatterService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "didInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsert"), _class.prototype)), _class));
export { MarketInputPhone as default };